module.exports = __webpack_public_path__ + "static/media/rajasthan2.8d521d41.jpg";